'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _Slider = require('../utils/Slider');

var _Slider2 = _interopRequireDefault(_Slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DynamicLogoCarousel = function () {
  function DynamicLogoCarousel(section) {
    (0, _classCallCheck3.default)(this, DynamicLogoCarousel);

    this.el = section.el;

    this.flickity = new _Slider2.default(this.el.querySelector('.as-seen-on-logo-carousel'), {
      wrapAround: true,
      autoPlay: this.autoPlay,
      pauseAutoPlayOnHover: false,
      pageDots: false,
      arrowShape: {
        x0: 15,
        x1: 55, y1: 40,
        x2: 60, y2: 40,
        x3: 20
      }
    });
  }

  (0, _createClass3.default)(DynamicLogoCarousel, [{
    key: 'selectedHeight',
    value: function selectedHeight() {}
  }, {
    key: 'lockSlide',
    value: function lockSlide(event) {
      this.slidesLocked = true;

      this.jumpToSlide(event);
      this.selectedHeight();
    }
  }, {
    key: 'unlockSlide',
    value: function unlockSlide() {
      this.slidesLocked = false;
    }
  }, {
    key: 'nextSlide',
    value: function nextSlide() {
      this.flickity.next(true, false);
    }
  }, {
    key: 'previousSlide',
    value: function previousSlide() {
      this.flickity.previous(true, false);
    }
  }, {
    key: 'jumpToSlide',
    value: function jumpToSlide(event) {
      if (this.flickity.slides.length) {
        var jumpPosition = this.flickity.slides.findIndex(function (_ref) {
          var slide = _ref.slide;
          return slide === event.target;
        });
        if (~jumpPosition) {
          this.switchToSlide(jumpPosition);
        }
      }
    }
  }, {
    key: 'switchToSlide',
    value: function switchToSlide(jumpPosition) {
      this.flickity.select(jumpPosition);
    }
  }, {
    key: 'onSectionBlockSelect',
    value: function onSectionBlockSelect(data) {
      var event = {
        target: data.el
      };

      this.lockSlide(event);
    }
  }, {
    key: 'onSectionBlockDeselect',
    value: function onSectionBlockDeselect() {
      this.unlockSlide();
    }
  }, {
    key: 'onSectionUnload',
    value: function onSectionUnload() {
      this.flickity.destroy();
    }
  }]);
  return DynamicLogoCarousel;
}();

exports.default = DynamicLogoCarousel;